module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1512-9420ddb9204d8c17259517d2e609511a.png";